<template>
  <div>
    <vs-prompt
      :active.sync="showDialog"
      :class="modalClass"
      buttons-hidden
      id="common-modal"
    >
      <!-- タイトル -->
      <div id="title" class="flex items-center justify-between mb-4">
        <common-text-medium :text="title" />

        <!-- 閉じるボタン -->
        <div class="close-button">
          <feather-icon icon="XIcon" svgClasses="h-6 w-6" @click="close()" />
        </div>
      </div>

      <div :class="contentsClass">
        <!-- コンテンツ -->
        <slot name="contents"></slot>
      </div>

      <div>
        <!-- ボタンエリア -->
        <slot name="buttons"></slot>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import CommonTextMedium from "../atoms/CommonTextMedium";

/*
 * 基本のモーダルコンポーネント
 * @props title: String モーダルのタイトル
 * @props showBackGround:Boolean モーダルの黒背景の表示/非表示
 */

export default {
  components: { CommonTextMedium },
  name: "O.CommomModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    showBackground: {
      type: Boolean,
      required: false,
      default: true,
    },
    modalClass: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    contentsClass: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    toggleRegist() {
      this.accept();
    },
    toggleCancel() {
      this.cancel();
      this.close();
    },

    show() {
      this.showDialog = true;
    },

    close() {
      this.$nextTick(() => {
        this.showDialog = false;
      });
    },
    removeBackground() {
      const el = document
        .getElementById("common-modal")
        .querySelector(".vs-dialog-dark");
      el.remove();
    },
  },

  mounted() {
    if (!this.showBackground) {
      this.removeBackground();
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
#common-modal {
  .vs-dialog {
    --vs-primary: $aisea-blue;
    width: fit-content;
    max-width: 800px;
    min-width: 500px;
    .vs-dialog-header {
      display: none;
    }
  }

  .close-button {
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>
